import { code } from "@spscommerce/utils";

export const SpsGrowlerExamples = {
  styles: {
    label: "Styles",
    examples: {
      success: {
        template: code`
          <sps-button (click)="renderGrowler = !renderGrowler">Show/Reset</sps-button>
          <sps-growler kind="success" title="Success!" *ngIf="renderGrowler">
            Your document has been sent.
          </sps-growler>
        `,
        class: code`
          class DemoComponent {
            renderGrowler = false;
          }
        `,
      },
      error: {
        template: code`
          <sps-button (click)="renderGrowler = !renderGrowler">Show/Reset</sps-button>
          <sps-growler kind="error" title="Error!" *ngIf="renderGrowler">
            Your document has not been sent.
          </sps-growler>
        `,
        class: code`
          class DemoComponent {
            renderGrowler = false;
          }
        `,
      },
      warning: {
        template: code`
          <sps-button (click)="renderGrowler = !renderGrowler">Show/Reset</sps-button>
          <sps-growler kind="warning" title="Offline" *ngIf="renderGrowler">
            No internet connection detected.
          </sps-growler>
        `,
        class: code`
          class DemoComponent {
            renderGrowler = false;
          }
        `,
      },
      info: {
        template: code`
          <sps-button (click)="renderGrowler = !renderGrowler">Show/Reset</sps-button>
          <sps-growler kind="info" title="Systems Maintenance Notice" *ngIf="renderGrowler">
            We'll be offline tonight from 9-11pm CST.
          </sps-growler>
        `,
        class: code`
          class DemoComponent {
            renderGrowler = false;
          }
        `,
      },
      progress: {
        template: code`
          <sps-button (click)="renderGrowler = !renderGrowler">Show/Reset</sps-button>
          <sps-growler kind="progress" title="Export in Progress" *ngIf="renderGrowler">
            We'll let you know when it's done.
          </sps-growler>
        `,
        class: code`
          class DemoComponent {
            renderGrowler = false;
          }
        `,
      },
      activity: {
        template: code`
          <sps-button (click)="renderGrowler = !renderGrowler">Show/Reset</sps-button>
          <sps-growler kind="activity" title="Greg Alexander joined the Network"
           imgSrc="assets/images/greg_alexander.jpg"
           *ngIf="renderGrowler"
          >
            <a href="#">Click to view details</a>
          </sps-growler>
        `,
        class: code`
          class DemoComponent {
            renderGrowler = false;
          }
        `,
      },
    }
  },
  events: {
    label: "Events",
    examples: {
      close: {
        template: code`
          <sps-button (click)="renderGrowler = !renderGrowler">Show/Reset</sps-button>
          <sps-growler kind="success" title="Success!"
           (close)="onGrowlerClose()" *ngIf="renderGrowler"
          >
            Your document has been sent.
          </sps-growler>
        `,
        class: code`
          class DemoComponent {
            renderGrowler = false;

            onGrowlerClose() {
              console.log("Closed growler.");
            }
          }
        `,
      }
    }
  },
  service: {
    label: "Service",
    examples: {
      service: {
        template: code`
          <sps-button (click)="growl()">Create growler</sps-button>
          <ng-template #growlerContent>Your document has been sent.</ng-template>
        `,
        class: code`
          import { SpsGrowlerService } from "@spscommerce/ds-ng-growler";
          import { GrowlerKind } from "@spscommerce/ds-shared";

          // @Component({ ... })
          class DemoComponent {
            @ViewChild("growlerContent", { static: false }) growlerContent: TemplateRef<any>;

            constructor(private growlerService: SpsGrowlerService) {}

            growl() {
              this.growlerService.createGrowler({
                kind: GrowlerKind.SUCCESS,
                title: "Success!",
                content: this.growlerContent,
                onClose() {
                  console.log("Closed growler.");
                }
              });
            }
          }
        `,
      }
    }
  }
};
